import { get, put } from "../utils/request";

const requestList = {
  getOrderList: "/xxy/product/order/list",
  queryOrderList: "/xxy/product/order/listOrder",
  editOrder: "/xxy/product/order/getInfo",
  delOrder: "/xxy/product/order/remove",
  getMaster: "/xxy/basic/material/getInfo",
  updateOrder: "/xxy/product/order/toReport",
  addOrder: "/xxy/product/order/save",
  changeStatus: "/xxy/product/order/changeStatus",
  //listColumnDO:'/xxy/basic/defineColumn/listColumnDO',
  generatePlan: "/xxy/product/order/generatePlan",
  getClient: "/xxy/basic/client/listAll",
  getSupplier: "/xxy/basic/supplier/listAll",
  batchGeneratePlan: "/xxy/product/order/orderRelease",
  getAddress: "/xxy/basic/clientAddress/listAll",
  autoGeneratePlan: "/xxy/product/order/generatePlan",
  getWithCheck:'/xxy/product/order/generatePlanWithCheck',
  getCancel:'/xxy/product/order/cancel',//取消按钮
};

export function gets(type) {
  return async function (data, options) {
    return await get(requestList[type], data, options);
  };
}
export function posts(type) {
  return async function (data, options) {
    return await put(requestList[type], data, options);
  };
}
